const axios = require('axios');
const apios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})
export default apios